import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useNote(taskId, shouldGetNotes) {
  const { data, _error, isLoading, mutate } = useSWR(
    shouldGetNotes && taskId ? `/tasks/${taskId}/notes` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    notes: data,
    isLoading,
    mutate: mutate,
  };
}

export default useNote;
